// extracted by mini-css-extract-plugin
export var active = "pricing-calulator-module--active--f363e";
export var asterisk = "pricing-calulator-module--asterisk--9e1fa";
export var characterLimit = "pricing-calulator-module--characterLimit--fbab0";
export var chevron = "pricing-calulator-module--chevron--76009";
export var closedCollapsibleHeader = "pricing-calulator-module--closedCollapsibleHeader--2a39e";
export var creditInfoContainer = "pricing-calulator-module--creditInfoContainer--d7ae8";
export var creditType = "pricing-calulator-module--creditType--e5c62";
export var desktop = "pricing-calulator-module--desktop--59037";
export var desktopTypeLabel = "pricing-calulator-module--desktopTypeLabel--53f14";
export var destination = "pricing-calulator-module--destination--c37cd";
export var disclaimer = "pricing-calulator-module--disclaimer--4f6eb";
export var disclaimerContainer = "pricing-calulator-module--disclaimerContainer--f343d";
export var dropdown = "pricing-calulator-module--dropdown--09620";
export var dropdownContainer = "pricing-calulator-module--dropdownContainer--c2848";
export var flexContainer = "pricing-calulator-module--flexContainer--a6d75";
export var headline = "pricing-calulator-module--headline--ae9e0";
export var icon = "pricing-calulator-module--icon--64e54";
export var input = "pricing-calulator-module--input--93022";
export var label = "pricing-calulator-module--label--dfe31";
export var leftSection = "pricing-calulator-module--leftSection--441dd";
export var maxSends = "pricing-calulator-module--maxSends--78201";
export var messagingContainer = "pricing-calulator-module--messagingContainer--18f9f";
export var messagingContainerClosed = "pricing-calulator-module--messagingContainerClosed--b270b";
export var messagingContainerOpen = "pricing-calulator-module--messagingContainerOpen--adaca";
export var mobile = "pricing-calulator-module--mobile--78784";
export var mobileContainer = "pricing-calulator-module--mobileContainer--c9ddc";
export var mobileContent = "pricing-calulator-module--mobileContent--5f5b4";
export var mobileCredits = "pricing-calulator-module--mobileCredits--a14fc";
export var mobileInputs = "pricing-calulator-module--mobileInputs--6624c";
export var mobileLabel = "pricing-calulator-module--mobileLabel--fcb30";
export var mobilePricePerSend = "pricing-calulator-module--mobilePricePerSend--b6bcd";
export var notAvailable = "pricing-calulator-module--notAvailable--35790";
export var open = "pricing-calulator-module--open--46432";
export var openCollapsibleHeader = "pricing-calulator-module--openCollapsibleHeader--3a6c6";
export var pricePerSend = "pricing-calulator-module--pricePerSend--32707";
export var pricingCalc = "pricing-calulator-module--pricingCalc--ac06b";
export var rightSection = "pricing-calulator-module--rightSection--43a62";
export var segment = "pricing-calulator-module--segment--39f55";
export var segmentedControl = "pricing-calulator-module--segmentedControl--3879f";
export var selectedLocale = "pricing-calulator-module--selectedLocale--82a4c";
export var toggleContainer = "pricing-calulator-module--toggleContainer--8e428";
export var type = "pricing-calulator-module--type--a7ea3";